import type { ReactNode } from "react";
import type { RouteObject } from "react-router";
import { Link, useParams } from "react-router";
import { NurMitBetraegen } from "../../../app/betraege";
import { t } from "../../../lib/sprache";
import { Vertraege } from "./Vertraege";
import { VertragNeu } from "./VertragNeu";
import { Vertrag } from "./Vertrag";
import { VertragSenden } from "./VertragSenden";
import { VertragDruck } from "./VertragDruck";
import { Vorlagen } from "./Vorlagen";
import { VorlageEditor } from "./VorlageEditor";
import { VertragImport } from "./VertragImport";
import { Baukasten } from "./baukasten/Baukasten";
import { Klauseln } from "./baukasten/Klauseln";
import { AssistentEntwurf, AssistentStart } from "./baukasten/Assistent";

/**
 * Verträge enthalten Honorare und Konditionen. Wer das Recht „Beträge sehen“ nicht hat, sieht die Liste und die Vorlagen,
 * aber keinen Vertragstext (Praxistest K-037).
 */
const mitBetraegen = (seite: ReactNode) => <NurMitBetraegen was={t("Verträge enthalten Honorare und Konditionen.", "Contracts contain fees and terms.")}>{seite}</NurMitBetraegen>;

export const vertraegeRoutes: RouteObject[] = [
  { path: "vertraege", element: <Vertraege /> },
  { path: "vertraege/neu", element: mitBetraegen(<VertragNeu />) },
  { path: "vertraege/assistent", element: mitBetraegen(<AssistentStart />) },
  { path: "vertraege/assistent/:contractId", element: mitBetraegen(<AssistentEntwurf />) },
  { path: "vertraege/vorlagen", element: <Vorlagen /> },
  { path: "vertraege/klauseln", element: <Klauseln /> },
  { path: "vertraege/vorlagen/import", element: <VertragImport /> },
  { path: "vertraege/vorlagen/:templateId", element: <NurMitVorlagenId><VorlageEditor /></NurMitVorlagenId> },
  { path: "vertraege/vorlagen/:templateId/baukasten", element: <NurMitVorlagenId><Baukasten /></NurMitVorlagenId> },
  { path: "vertraege/:contractId", element: mitBetraegen(<Vertrag />) },
  { path: "vertraege/:contractId/senden", element: mitBetraegen(<VertragSenden />) },
  { path: "vertraege/:contractId/druck", element: mitBetraegen(<VertragDruck />) },
];

/**
 * Vertippte Adresse wie /agentur/vertraege/vorlagen/galerie (Nachtest 15.10.2026): ohne gültige Kennung „Seite nicht gefunden“
 * statt der Datenbankmeldung „Eine Eingabe hat ein ungültiges Format“.
 */
function NurMitVorlagenId({ children }: { children: ReactNode }) {
  const { templateId } = useParams();
  if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(templateId ?? "")) {
    return (
      <main id="main" className="content">
        <div className="panel stack tk-empty" role="status">
          <h1 className="tk-state-title">{t("Seite nicht gefunden", "Page not found")}</h1>
          <p>{t("Diese Vorlage gibt es nicht. Prüfe den Link oder öffne die Vorlagen.", "This template does not exist. Check the link or open the templates.")}</p>
          <div className="row"><Link className="btn" to="/agentur/vertraege/vorlagen">{t("Zu den Vorlagen", "Go to templates")}</Link></div>
        </div>
      </main>
    );
  }
  return <>{children}</>;
}
